import {getProductFromPath} from '@/scripts/utils';

export const state = () => ({
  events: []
});

export const mutations = {
  setEvents (state, event) {
    state.events = [...state.events, event];
  }
};

export const actions = {
  sendEventToMatomo ({ dispatch, commit, getters, rootGetters, ...context }, event) {
    // if (typeof window === 'undefined') { // only need to check if window is defined if using old way
    //   return;
    // }
    if (process.server) return;
    if (this.$config.environment !== 'production') {
      return;
    }

    if (!event.hasOwnProperty('name')) {
      console.log('name key was not found. Must provide a name for the event');
      return;
    }
    const productCategory = getProductFromPath(this.$router.currentRoute.path) || rootGetters['utils/getProductFromMeta'];
    if (productCategory === 'Product Unknown' && context.$honeybadgerGeneric) {
      context.$honeybadgerGeneric.addBreadcrumb('Product Category for Matomo not found', {
        event: event
      });
    }
    event.category = productCategory;

    const url = 'https://matomo.bonkers.ie/piwik.php?idsite=1&rec=1&apiv=1&e_c=' +
      encodeURIComponent(event.category) + '&e_a=' +
      encodeURIComponent(event.action) + '&e_n=' +
      encodeURIComponent(event.name);

    // Set the user ID if available
    const user = rootGetters['user/get'];
    if (user && user.email) window._paq.push(['setUserId', user.email]);

    // Create a new image and set its src to the tracking URL
    const image = new Image();
    image.src = url;

    // Old way
    // event.value !== null ? window._paq.push(['trackEvent', event.category, event.action, event.name, event.value]) : window._paq.push(['trackEvent', event.category, event.action, event.name]);
    commit('setEvents', event);
  },
  sendUserID (userPayload) {
    if (process.server) return;
    if (this.$config.environment !== 'production') {
      return;
    }

    if (userPayload.email) window._paq.push(['setUserId', userPayload.email]);
  },
  trackAPIError ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'API Error';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackIndexPageViewed ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Index Page Viewed';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackCTAClick ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'CTA Click';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackFunnelStepCompleted ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Funnel Step Completed';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackError ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Error';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackFilterChange ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Filters Changed';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackOrderCompleted ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Order Completed';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackProceedToProvider ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Proceed to Provider';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackResultsReached ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Results Reached';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackViewingProduct ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Viewing Product';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackCallbackArranged ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Callback Arranged';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
  },
  trackProviderContacted ({ dispatch, commit, getters, rootGetters }, payload) {
    const actionName = 'Provider Contacted';
    payload.action = actionName;
    dispatch('sendEventToMatomo', payload);
}
};

export const getters = {
  getEvents (state) {
    return state.events;
  }
};
